<script>
import { baseTermUrl } from 'base/config'
import { liabilities } from 'api/index'
export default {
  name: 'SingleInsurance',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    templateData: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {
      singleInsurance: {
        name: '',
        imgList: [],
        url: '',
      },
    }
  },
  computed: {
    isShow() {
      const { value, singleInsurance } = this
      return (
        value &&
        singleInsurance &&
        Array.isArray(singleInsurance.imgList) &&
        singleInsurance.imgList.length
      )
    },
  },
  created() {
    const { card, resultData } = this.templateData
    if (
      resultData.insuranceTypeId === -1 &&
      !this.templateData.liabilities[0].insuranceLiabilities[0].liabilities
    ) {
      const ins =
        resultData.productGroupList[0].prodOrderList[0].mulInsOrderList[0]
      if (!ins || !ins.key || ins.key === -1) {
        this.$emit('input', false)
        return
      }
      liabilities({}, `${ins.key}/liabilities`).then(
        ({ data: { success, data } } = { data: {} }) => {
          this.singleInsurance.name = ins.name
          this.singleInsurance.imgList = data
          this.singleInsurance.url = `${baseTermUrl}?nw=1&name=${card.name}&termsId=${ins.key}`
        }
      )
    } else {
      this.$emit('input', false)
    }
  },
}
</script>
<template>
  <div v-if="isShow" class="terms-img">
    <div class="hd">
      {{ singleInsurance.name
      }}<a :href="singleInsurance.url" class="term-link after-bdr">条款</a>
    </div>
    <div class="bd">
      <img
        v-for="(item, index) in singleInsurance.imgList"
        :key="index"
        :src="item.picUrl"
        :alt="item.comment"
      >
    </div>
  </div>
</template>
<style lang="postcss" scoped>
.terms-img {
  position: relative;
  border-radius: 4px;
  background-color: #fff;
  width: 94.667%;
  margin: 0 auto;
  margin-bottom: 10px;
  .hd {
    padding: 15px 20px 0 30px;
    margin-bottom: 6px;
    color: #333;
    font-size: 16px;
    font-weight: 700;
    a {
      z-index: 1;
      float: right;
      padding: 5px 10px 3px;
      font-size: 12px;
      font-weight: 400;
      line-height: 1;
      color: #ce8b00;
      background-color: #fffaef;
      &:after {
        border-radius: 100px;
      }
    }
  }
  .bd {
    img {
      width: 100%;
      vertical-align: middle;
    }
  }
}
</style>
